<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>推广管理</a-breadcrumb-item>
    <a-breadcrumb-item>达人备案</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <!-- 日期： -->
          <a-col :span="6" class="tool-title">日期：</a-col>
          <a-col :span="18">
            <a-range-picker 
              v-model:value="dateRange" 
              class="tool-item"
              format="YYYY-MM-DD"
              :placeholder="['开始日期', '结束日期']"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 账号昵称： -->
          <a-col :span="6" class="tool-title">账号昵称：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nicknameModel" class="tool-item" placeholder="请输入名称" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <!-- 保留布局结构 -->
      </a-col>
      <a-col :span="6">
        <!-- 保留布局结构 -->
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 备案时间 -->
      <template v-if="column.key === 'created_time'">
        <a-tooltip :title="getFullDateTime(record[column.key])" placement="top">
          <span>{{ getShortDate(record[column.key]) }}</span>
        </a-tooltip>
      </template>
      <!-- 主页链接 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchViewHomepage(record)">查看</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
// 引入 API
import { darenRecordList } from '@/api/admin'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
// 引入公共方法
import Pub from '@/utils/public'

// 日期范围
let dateRange = ref([dayjs().subtract(30, 'day'), dayjs()])
// 账号昵称
let nickname = ref(undefined)
let nicknameModel = ref(undefined)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '备案时间',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '服务商名称',
    dataIndex: 'reseller_name',
    key: 'reseller_name'
  },
  {
    title: '账号昵称',
    dataIndex: 'nickname',
    key: 'nickname'
  },
  {
    title: '备案平台',
    dataIndex: 'platform_name',
    key: 'platform_name'
  },
  {
    title: '主页链接',
    dataIndex: 'operation',
    key: 'operation'
  }
])

onBeforeMount (() => {
  // 初始化获取
  touchSearch()
})

// 获取短日期格式 (YYYY-MM-DD)
function getShortDate (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD')
}

// 获取完整日期时间格式 (YYYY-MM-DD HH:mm:ss)
function getFullDateTime (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getTalentRecordList()
}

// 查询
function touchSearch () {
  // 调整参数
  nickname.value = nicknameModel.value
  pagination.current = 1
  // 获取列表
  getTalentRecordList()
}

// 重置
function touchReset () {
  nicknameModel.value = undefined
  nickname.value = undefined
  dateRange.value = [dayjs().subtract(30, 'day'), dayjs()]
  // 初始化获取
  touchSearch()
}

// 查看主页
function touchViewHomepage (record) {
  // 新窗口访问百度
  Pub.OPEN_URL(record.home_link)
}

// 获取列表
function getTalentRecordList () {
  isLoading.value = true
  const params = {
    name: nickname.value,
    start_time: dateRange.value && dateRange.value[0] ? dateRange.value[0].format('YYYY-MM-DD') : undefined,
    end_time: dateRange.value && dateRange.value[1] ? dateRange.value[1].format('YYYY-MM-DD') : undefined,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  // TODO: 替换为实际的API调用
  darenRecordList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>

.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}
</style>
